<!-- 
<template>
  <div class="child-container">
      <div v-if="loading" class="d-flex justify-content-center">
        <div class="spinner-border position-absolute spinner-class"></div>
      </div>
      <div v-if="(!loading)">
        <p :style="{
            'font-weight': '700',
            'font-size': '32px',
            'line-height': '42px',
          color: '#0F1734',
          }">Recent Activity</p>
        <div v-if="updates">
          <div v-for="(update, index) in updates" :key="index">
          <Post v-if="update.content_type === 'post'" :postData="update"></Post>
          <Question
            v-if="update.content_type === 'question'"
            :quesData="update.user_question"
          ></Question>
          <div v-if="update.content_type === 'poll'">
            <PollCard :pollData="update.user_poll" />
          </div>
          </div>
          <span
            v-if="updates.length != pagination.total_count"
            class="viewmore"
            :style="{
              color: getPrimaryColor(),
              textAlign: 'center',
              display: 'block',
              cursor: 'pointer',
            }"
            @click="fetch(true)"
            >View More</span
          >
        </div>
        <div v-if="!updates" class="text-center">
          <div class="dailogbox">
            <div class="dailog-wrapper">
              <span class="dailog">You have not created any posts yet.</span>
                <button 
                class="get-started-btn"
                @click="pushToHome">
                    Create Post
                </button>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>


<script>
import Post from "../../../home/Post";
import QuestionCard from "../QA/Question.vue";
import PollCard from "../../../home/poll/UserPollCard.vue";
// import UserProfilePost from "../../../home/UserProfilePost.vue";
import { RepositoryFactory } from "../../../../repositories/RepositoryFactory";

const UserRepository = RepositoryFactory.get("user");
const PostRepository = RepositoryFactory.get("posts");

export default {
  name: "ViewPatientUpdates",
  components: {
    Post,
    Question,
    PollCard
  },
  data() {
    return {
      updates: [],
      posts:[],
      pagination: null,
      currentPage: 1,
      limit: 2,
      userId: null,
      user: null,
      inCircle: false,
      postPayload: {
        post_text: "",
        day_type: ""
      },
      loading: false,
      showNo: true
    };
  },

  created() {
    this.userId = this.$route.params.id;
    this.fetch();
    console.log("ASDASD::::::::;");
  },

  methods: {
    /**
     * Post Updates
     * @description Create a post on viewing other's profile which will
     * be visible as updates in their updates section
     */

     pushToHome() {
      this.$router.push({ name: "ActivityHome" });
    },

    postUpdates() {
      this.loading = true;
      const payload = {
        user_circle: this.currentCircle.id,
        user: this.authUser.user.id,
        role: this.authUser.role,
        day_type: this.postPayload.day_type,
        post_text: this.postPayload.post_text,
        receiver_user: this.viewUser.id,
        receiver_role: this.viewUser.role
      };
      PostRepository.createPost(payload)
        .then(res => {
          this.loading = false;
          this.postPayload.post_text = "";
          this.$notification.success({
            message: "Success",
            description: "Message Delivered Successfully."
          });
          this.fetch(false, 1);
        })
        .catch(err => {
          this.loading = false;
        });
    },

    requestToAdd() {
      UserRepository.requestToAdd(this.viewUser, this.currentCircle.id)
        .then(res => {
          this.$store.state.User.viewUser.request_to_add = "pending";
          //
        })
        .catch(err => {
          console.error(err);
        });
    },

    fetch(append = false, page = this.currentPage) {
      this.showNo=true;
      UserRepository.getUpdatesWithReceiver(
        page,
        this.limit,
        this.viewUser,
        this.currentCircle.id
      )
        .then(res => {
          this.showNo = true;
          if (append) {
            this.updates.push(...res.data.data.data);
          } else {
            if (res.data) {
              this.updates = res.data.data.data ? res.data.data.data : [];
              this.updates.map((update)=>{
                  if(update.content_type==='post'){
                    this.posts.push(update)
                  }
              })
              this.pagination = res.data.data.paginator
                ? res.data.data.paginator.total_count
                : [];
                this.showNo=false;
            }
          }
          this.currentPage += 1;
        })
        .catch(err => {});
        this.showNo=false;
    }
  }
};
</script>

<style lang="scss" scoped>

.viewmore{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;
  gap: 4px;
  background: #F1F5F9;
  border-radius: 8px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 20px;
}


.get-started-btn{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 121px;
        height: 48px;
        background: #062B54;
        border-radius: 6px;
        font-weight: 700;
        font-size: 14px;
        line-height: 24px;
        text-align: center;
        text-transform: capitalize;
        color: #FFFFFF;
        border: none;
    }

    .dailog{
        font-weight: 700;
        font-size: 20px;
        line-height: 30px;
        text-align: center;
        color: #0F1734;
    }

    .dailog-wrapper{
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0px;
        gap: 8px;
        width: 100%;
        // height: 115px;
    }

    .dailogbox{
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 24px;
        gap: 24px;
        width: 100%;
        // height: 163px;
        background: #F1F5F9;
        border-radius: 8px;
    }

.child-container{
    width: 790px;
    // height: 2716px;
}
.activity-header{
  font-family: 'Lato';
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 42px;
    color: #0F1734;
    margin-bottom: 32px;
}

@media screen and (max-width: 581px) {
  .request-card-ask {
    margin-right: 10px;
  }
  .shadow-card {
    display: flex;
    flex-direction: column;

    p {
      max-width: 100%;
      padding-bottom: 5px;
    }

    .dovemed-button {
      margin: 0 auto;
      cursor: pointer;
    }

    .after{
      cursor: default;
    }

  }
}
</style> -->

<template class="child-container">
  <div class="w-100">
    <p :style="{ 'font-weight': '700', 'font-size': '32px', 'line-height': '42px', color: '#0F1734' }">Recent Activity</p>
    <!-- <div v-if="updates.length"> -->
    <div v-for="(update, index) in updates" :key="index">
      <Post
        :handleOtherModals="handleOtherModals"
        v-if="update.content_type === 'post'"
        :postData="{ ...update, postId: update.id }"
        v-on:refresh="fetch()"
        :fetchPosts="fetch"
        :showFullScreen="showFullScreen"
      />
      <QuestionCard :fetchPosts="fetch" v-if="update.content_type === 'question'" :quesData="update.user_question" :showFullScreen="showFullScreen"></QuestionCard>
      <PollCard v-if="update.content_type === 'poll' && update.user_poll" :pollData="{ ...update.user_poll, postId: update.id }"></PollCard>
      <Post
        v-if="update.content_type === 'job'"
        :postData="{ ...update.user_job, content_type: update.content_type, postId: update.id, sponsered: update.sponsered, user: [update.user_job.user], allow_comments: update.allow_comments }"
        v-on:refresh="fetch()"
        :fetchPosts="fetch"
        :handleOtherModals="handleOtherModals"
      />
      <Post
        v-if="update.content_type === 'press' || update.content_type === 'pressRelease'"
        :postData="{ ...update.user_press, content_type: update.content_type, postId: update.id, sponsered: update.sponsered, user: [update.user_press.user], allow_comments: update.allow_comments }"
        v-on:refresh="fetch()"
        :fetchPosts="fetch"
        :handleOtherModals="handleOtherModals"
      />
      <Post
        v-if="update.content_type === 'event'"
        :postData="{ ...update.user_event, content_type: update.content_type, postId: update.id, sponsered: update.sponsered, user: [update.user_event.user], allow_comments: update.allow_comments }"
        v-on:refresh="fetch()"
        :fetchPosts="fetch"
        :handleOtherModals="handleOtherModals"
      />
    </div>
    <div v-if="loading" class="d-flex justify-content-center">
      <div class="spinner-border position-absolute spinner-class"></div>
    </div>
    <span
      class="viewmore"
      v-if="updates.length && updates.length != pagination.total_count && !loading"
      :style="{ color: getPrimaryColor(), textAlign: 'center', display: 'block', cursor: 'pointer' }"
      @click="fetch(true)"
    >
      View More
    </span>
    <!-- </div> -->

    <div v-if="!loading && updates.length === 0" class="text-center">
      <div class="dailogbox">
        <div class="dailog-wrapper">
          <span class="dailog">This user hasn’t created any posts yet.</span>
        </div>
      </div>
    </div>
    <PostFullScreen ref="PostFullScreen" :postData="currentPostData" />
    <CreateNewPostModal ref="CreateNewPostModal" :getPost="fetch" :showCongrats="showCongrats" :handleOtherModals="handleOtherModals" />
    <congrats :showInfoModal="showInfoModal" ref="Congrats" />
    <info ref="Info" />
    <createEvent ref="EventModal" :handleOtherModals="handleOtherModals" />
    <createJob ref="JobModal" :handleOtherModals="handleOtherModals" />
    <createPressRelease ref="PressModal" :handleOtherModals="handleOtherModals" />
  </div>
</template>

<script>
import Post from "../../../home/Post"
import QuestionCard from "../../Patient/QA/Question"
import PollCard from "../../../home/poll/UserPollCard.vue"
import { RepositoryFactory } from "../../../../repositories/RepositoryFactory"
import PostFullScreen from "../../../Modals/activity/PostFullScreen.vue"
import CreateNewPostModal from "../../../Modals/CreateNewPost.vue"
import Congrats from "../../../Modals/activity/Congrats.vue"
import Info from "../../../Modals/activity/Info.vue"
import createEvent from "../../../Modals/createEvent.vue"
import createJob from "../../../Modals/createJob.vue"
import createPressRelease from "../../../Modals/createPressRelease.vue"
import { mapGetters } from "vuex"

const UserRepository = RepositoryFactory.get("user")
const PostRepository = RepositoryFactory.get("posts")

export default {
  name: "PatientUpdates",
  components: {
    Post,
    QuestionCard,
    PollCard,
    PostFullScreen,
    Congrats,
    CreateNewPostModal,
    Info,
    createEvent,
    createJob,
    createPressRelease,
  },
  data() {
    return {
      updates: [],
      pagination: null,
      currentPage: 2,
      limit: 5,
      userId: null,
      user: null,
      inCircle: false,
      postPayload: { post_text: "", day_type: "" },
      loading: false,
      showNo: false,
    }
  },

  created() {
    console.warn("ViewPatientUpdates.vue created")
    this.userId = this.$route.params.id
    this.fetch()
  },

  computed: {
    ...mapGetters({ msg: "Posts/msg" }),
  },

  watch: {
    msg(v) {
      if (v) {
        this.fetch()
      }
      this.$store.commit("Posts/setMsg", false)
    },
  },

  methods: {
    showCongrats() {
      this.$refs.Congrats.show()
    },

    handleOtherModals(modalToOpen, data = null, type = "post", editing = false, tags = [], id) {
      // console.log("handleOtherModals ->", modalToOpen)
      // console.log("editing ->", editing)
      // console.log("data ->", data)
      // this.$refs.CreateNewPostModal.hide()
      switch (modalToOpen) {
        case "pressRelease":
        case "press":
          this.$refs.PressModal.show(data, editing, tags, id)
          break
        case "job":
          this.$refs.JobModal.show(data, editing, tags, id)
          break
        case "event":
          this.$refs.EventModal.show(data, editing, tags, id)
          break
        case "add":
        case "new":
        case "edit":
          this.$refs.CreateNewPostModal.show(editing ? "edit" : "add", data, type, tags, id)
          break
        case "more":
        case "back":
        case "moreOptions":
          this.$refs.CreateNewPostModal.show("more", data, type, tags, id)
          break
      }
    },

    showInfoModal() {
      this.$refs.Info.show()
    },

    showFullScreen(d) {
      this.$refs.PostFullScreen.show(d)
    },

    pushToHome() {
      this.$router.push({ name: "ActivityHome" })
    },

    // fetchPosts() {
    //   this.updates=[];
    //   UserRepository.getUpdates(
    //     1,
    //     this.limit,
    //     this.viewUser,
    //     this.currentCircle.id
    //   )
    //   .then(res => {
    //       if (res.data) {
    //         this.updates = res.data.data.data;
    //         this.pagination = res.data.data.paginator
    //           ? res.data.data.paginator
    //           : {};
    //         console.log(this.pagination,"pagination cons");
    //       }
    //     })
    //     .catch(err => {
    //       console.log(err)
    //     })
    // },

    fetch(append = false) {
      this.loading = true
      if (append) {
        UserRepository.getUpdates(this.currentPage, this.limit, this.viewUser, this.currentCircle.id)
          .then(res => {
            // console.log("data:", res.data.data.data)
            this.updates.push(...res.data.data.data)
            this.currentPage += 1
            this.loading = false
          })
          .catch(e => {
            this.loading = false
          })
      } else {
        this.updates = []
        UserRepository.getUpdates(1, this.limit, this.viewUser, this.currentCircle.id)
          .then(res => {
            // console.log("data:", res.data.data.data)
            if (res.data) {
              this.updates = res.data.data.data ? res.data.data.data : []
              this.pagination = res.data.data.paginator ? res.data.data.paginator : {}
              this.loading = false
              // console.log("pagination:", this.pagination)
            }
          })
          .catch(e => {
            this.loading = false
          })
      }
      console.log("updates ->", this.updates)
    },

    postUpdates() {
      this.loading = true
      const payload = {
        user_circle: this.currentCircle.id,
        user: this.authUser.user.id,
        day_type: this.postPayload.day_type,
        post_text: this.postPayload.post_text,
        receiver_user: this.viewUser.id,
      }
      PostRepository.createPost(payload)
        .then(res => {
          this.loading = false
          this.postPayload.post_text = ""
          this.fetch(false, 1)
        })
        .catch(err => {
          this.loading = false
        })
    },

    // fetch(append = false, currentPage = this.currentPage) {
    //   this.authUser.user.role
    //     ? UserRepository.getUpdates(
    //         currentPage,
    //         this.limit,
    //         this.viewUser,
    //         this.currentCircle.id
    //       )
    //         .then(res => {
    //           this.showNo = true;
    //           if (append) {
    //             this.updates.push(...res.data.data.data);
    //             // this.currentPage += 1;
    //           } else {
    //             this.updates=[];
    //             if (res.data) {
    //               // this.updates=[];
    //               this.updates = res.data.data.data?res.data.data.data:[];
    //               console.log(this.updates);
    //               this.pagination = res.data.data.paginator;
    //             }
    //           }
    //           this.currentPage += 1;
    //         })
    //         .catch(err => {})
    //     : UserRepository.getUpdatesHospital(
    //         currentPage,
    //         this.limit,
    //         this.viewUser,
    //         this.currentCircle.id
    //       )
    //         .then(res => {
    //           this.showNo = true;
    //           if (append) {
    //             this.updates.push(...res.data.data.data);
    //             this.currentPage += 1;
    //           } else {
    //             this.updates=[];
    //             if (res.data) {
    //               // this.updates=[];
    //               this.updates = res.data.data.data;
    //               this.pagination = res.data.data.paginator;
    //             }
    //           }
    //           console.log(this.updates);
    //           // this.currentPage += 1;
    //         })
    //         .catch(err => {});
    // }
  },
}
</script>

<style scoped lang="scss">
.child-container {
  width: 790px;
  // height: 2716px;
}

.viewmore {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;
  gap: 4px;
  background: #f1f5f9;
  border-radius: 8px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 20px;
}

.top {
  width: 100%;
}

.get-started-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 121px;
  height: 48px;
  background: #062b54;
  border-radius: 6px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  text-transform: capitalize;
  color: #ffffff;
  border: none;
}

.dailog {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #33415f;
}

.dailog-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 100%;
  // height: 115px;
}

.dailogbox {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 24px;
  width: 100%;
  // height: 163px;
  background: #f1f5f9;
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Patient/view/ViewPatientUpdates.vue